/**
 * Single source for "current user" and "resolved role" to avoid bugs from
 * missing/malformed localStorage or JWT.
 */

import { isAdminSpaceUser } from './accessControlUtils'

export function getStoredUser() {
  try {
    const s = localStorage.getItem('user');
    if (!s) return null;
    return JSON.parse(s);
  } catch {
    return null;
  }
}

export function resolveUserRole(user) {
  if (!user) return null;
  const r = user.role || user.userType;
  if (r === 'admin' || r === 'Super Admin') return 'admin';
  if (r === 'affilie') return 'affilie';
  if (r === 'client' || r === 'partenaire' || r === 'partner') return 'client';
  return r || null;
}

export function getDefaultPathForRole(user) {
  // Land on the KPI tab directly — avoids /dashboard → /dashboard/kpi-commerciale bounce
  if (isAdminSpaceUser(user)) return '/dashboard/kpi-commerciale'
  const role = resolveUserRole(user)
  if (role === 'affilie' || role === 'client') return '/gestion-hotels/moteur_reservation'
  return '/login'
}

/**
 * Clears any locally persisted authentication session without redirecting.
 * Bypasses partner-protection guards by using the raw Storage prototype methods.
 * Returns true when a session was found & cleared, false otherwise.
 */
export function clearAuthSession() {
  const hadSession =
    typeof window !== 'undefined' &&
    !!(localStorage.getItem('user') || localStorage.getItem('accessToken'));

  if (!hadSession) return false;

  try {
    sessionStorage.setItem('_allowExplicitLogout', 'true');
  } catch {
    /* ignore */
  }

  const keys = ['user', 'accessToken', 'refreshToken', 'userInfo', 'lastActivityAt'];
  try {
    const rawRemove = Storage.prototype.removeItem;
    keys.forEach((key) => rawRemove.call(localStorage, key));
  } catch {
    keys.forEach((key) => {
      try {
        localStorage.removeItem(key);
      } catch {
        /* ignore */
      }
    });
  }

  try {
    sessionStorage.removeItem('_allowExplicitLogout');
  } catch {
    /* ignore */
  }

  return true;
}
